/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Times_Syntax_2Inputs */

const en_admin_resource_form_booking_times_syntax_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Days of the week are abbreviated with the first two letters of the English name.`)
};

const de_admin_resource_form_booking_times_syntax_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Wochentage werden mit den ersten beiden Buchstaben der englischen Bezeichnung abgekürzt.`)
};

const es_admin_resource_form_booking_times_syntax_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los días de la semana se abrevian con las dos primeras letras del nombre en inglés.`)
};

const fr_admin_resource_form_booking_times_syntax_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les jours de la semaine sont abrégés avec les deux premières lettres de leur nom anglais.`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */
const it_admin_resource_form_booking_times_syntax_2 = en_admin_resource_form_booking_times_syntax_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_times_syntax_2 = en_admin_resource_form_booking_times_syntax_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */
const pl_admin_resource_form_booking_times_syntax_2 = en_admin_resource_form_booking_times_syntax_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */
const hu_admin_resource_form_booking_times_syntax_2 = en_admin_resource_form_booking_times_syntax_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Syntax_2Inputs) => LocalizedString} */
const ro_admin_resource_form_booking_times_syntax_2 = en_admin_resource_form_booking_times_syntax_2;

/**
* | output |
* | --- |
* | "Days of the week are abbreviated with the first two letters of the English name." |
*
* @param {Admin_Resource_Form_Booking_Times_Syntax_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_times_syntax_2 = /** @type {((inputs?: Admin_Resource_Form_Booking_Times_Syntax_2Inputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Times_Syntax_2Inputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_times_syntax_2(inputs)
	if (locale === "de") return de_admin_resource_form_booking_times_syntax_2(inputs)
	if (locale === "es") return es_admin_resource_form_booking_times_syntax_2(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_times_syntax_2(inputs)
	if (locale === "it") return it_admin_resource_form_booking_times_syntax_2(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_times_syntax_2(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_times_syntax_2(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_times_syntax_2(inputs)
	return ro_admin_resource_form_booking_times_syntax_2(inputs)
});
export { admin_resource_form_booking_times_syntax_2 as "admin.resource_form.booking_times_syntax_2" }